
import index from '@/views/customer'
export default [
    {
        path: 'customer',
        component: index,
        name: 'Customer',
        meta: {
            nav: '客户案例'
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/customer.js